var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { a as assignGlobalSingleton } from "../global-33d5eebf.js";
const _Persist = class _Persist {
  constructor() {
    __publicField(this, "indexedDB");
  }
  async init() {
    this.indexedDB = new IndexedDB("persist");
    await this.indexedDB.init("persist");
    return Promise.resolve();
  }
  static getInstance() {
    return assignGlobalSingleton("PersistInstance", () => new _Persist());
  }
  set(key, value) {
    return this.indexedDB.saveObject(key, JSON.stringify(value));
  }
  async get(key) {
    if (Array.isArray(key)) {
      return (await this.indexedDB.listObjects(key)).map((o) => JSON.parse(o));
    }
    const res = await this.indexedDB.getObject(key);
    return JSON.parse(res);
  }
  async setIfMissing(key, value) {
    if (await this.indexedDB.hasKey(key)) {
      return this.get(key);
    }
    await this.set(key, value);
    return value;
  }
  async remove(key) {
    return this.indexedDB.deleteObject(key);
  }
  async listKeys() {
    return this.indexedDB.listKeys();
  }
  async hasKey(key) {
    return this.indexedDB.hasKey(key);
  }
};
__publicField(_Persist, "_instance");
let Persist = _Persist;
class IndexedDB {
  constructor(storeName) {
    __publicField(this, "db");
    __publicField(this, "storeName");
    this.storeName = storeName;
  }
  init(name) {
    return new Promise((resolve, reject) => {
      const request = window.indexedDB.open(name, 1);
      request.onerror = (evt) => {
        console.log("IndexedDB error: " + evt.target.errorCode);
        reject(evt.target.errorCode);
      };
      request.onsuccess = (evt) => {
        this.db = evt.target.result;
        resolve(evt.target.result);
      };
      request.onupgradeneeded = (evt) => {
        const objectStore = evt.currentTarget.result.createObjectStore(this.storeName, { keyPath: "key" });
        objectStore.createIndex("key", "key", { unique: true });
      };
    });
  }
  listKeys() {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction([this.storeName], "readonly");
      const objectStore = transaction.objectStore(this.storeName);
      const request = objectStore.getAllKeys();
      request.onsuccess = (evt) => {
        resolve(evt.target.result);
      };
      request.onerror = (evt) => {
        console.error("List keys error: " + evt.target.errorCode);
        reject(evt.target.errorCode);
      };
    });
  }
  hasKey(key) {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction([this.storeName], "readonly");
      const objectStore = transaction.objectStore(this.storeName);
      const request = objectStore.get(key);
      request.onsuccess = function() {
        if (request.result) {
          resolve(true);
        } else {
          resolve(false);
        }
      };
      request.onerror = function(event) {
        reject("Error occurred while checking for key: " + event);
      };
    });
  }
  listObjects(keys) {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction([this.storeName], "readonly");
      const objectStore = transaction.objectStore(this.storeName);
      let isRejected = false;
      if (keys) {
        const results = [];
        let pending = keys.length;
        for (const key of keys) {
          const request2 = objectStore.get(key);
          request2.onsuccess = (evt) => {
            results.push(evt.target.result);
            pending--;
            if (pending === 0 && !isRejected) {
              resolve(results);
            }
          };
          request2.onerror = (evt) => {
            console.log("List objects error: " + evt.target.errorCode);
            isRejected = true;
            reject(evt.target.errorCode);
          };
        }
        return;
      }
      const request = objectStore.getAll();
      request.onsuccess = (evt) => {
        if (!isRejected) {
          resolve(evt.target.result);
        }
      };
      request.onerror = (evt) => {
        console.error("List objects error: " + evt.target.errorCode);
        isRejected = true;
        reject(evt.target.errorCode);
      };
    });
  }
  saveObject(key, data) {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction([this.storeName], "readwrite");
      const objectStore = transaction.objectStore(this.storeName);
      const request = objectStore.put({ key, data });
      request.onsuccess = (evt) => {
        resolve(evt.target.result);
      };
      request.onerror = (evt) => {
        console.error("Save object error: " + evt.target.errorCode);
        reject(evt.target.errorCode);
      };
    });
  }
  getObject(key) {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction([this.storeName], "readonly");
      const objectStore = transaction.objectStore(this.storeName);
      const request = objectStore.get(key);
      request.onsuccess = (evt) => {
        var _a;
        resolve((_a = evt.target.result) == null ? void 0 : _a.data);
      };
      request.onerror = (evt) => {
        reject(evt.target.errorCode);
      };
    });
  }
  deleteObject(key) {
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction([this.storeName], "readwrite");
      const objectStore = transaction.objectStore(this.storeName);
      const request = objectStore.delete(key);
      request.onsuccess = (evt) => {
        resolve(evt.target.result);
      };
      request.onerror = (evt) => {
        console.error("Delete object error: " + evt.target.errorCode);
        reject(evt.target.errorCode);
      };
    });
  }
}
export {
  Persist
};
//# sourceMappingURL=persist.js.map
